export default {
  partner: {
    header: {
      title: 'Become our partner',
      description:
        'Manage your company with all-in-one software and increase your sales.',
      buttonLabel: 'Get started now or call: 0151/54252677',
    },
  },
}
